import TableRow from '@mui/material/TableRow';
import AppTableCell from 'src/components/appComponents/table/AppTableCell';
import { IChannelAiPublishJobsDto } from 'src/types/channelAiPublishJobs';

type Props = {
  row: IChannelAiPublishJobsDto;
};

export default function ChannelAiPublishJobsTableRow({ row }: Props) {
  return (
    <>
      <TableRow hover>
        <AppTableCell value={row?.jobId} />
        <AppTableCell value={row?.status} />
        <AppTableCell value={new Date(row?.createdAt)?.toLocaleDateString()} />
      </TableRow>
    </>
  );
}
